<template>
    <div class="levelup-mask">
      <div class="levelup-wrapper">
        <div class="levelup-container">
            <div class="levelup-image">
                <h1 class="levelup-title">LEVEL UP</h1>
                <img v-if="levelid == 1" src="../assets/img/lv2.png" />
                <img v-else-if="levelid == 2" src="../assets/img/lv3.png"/>
                <img v-else-if="levelid == 3" src="../assets/img/lv4.png"/>
                <img v-else-if="levelid == 4" src="../assets/img/lv5.png"/>
            </div>
            <div class="levelup-text">
            <p>축하합니다!</p>
            <p>칙령 제41호의 {{this.reporterlevel[levelid].value}}로 성장했습니다!</p>
            </div>
          <button class="levelup-button" @click="$emit('close')">
            OK
          </button>
        </div>
      </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    props: ['levelid'],
    data () {
        return{
            reporterlevel : [
                {id: 1, value: '독도 배움이'},
                {id: 2, value: '독도 알림이'},
                {id: 3, value: '독도 돌봄이'},
                {id: 4, value: '독도 지킴이'},
                {id: 5, value: '독도 지킴이'},
            ]
        }
    }
}
</script>

<style>
.levelup-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.levelup-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.levelup-container {
  width: 370px;
  margin: 0px auto;
  padding: 20px 30px;
  border: black solid 5px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.levelup-container p{
  text-align: center;
  font-size: 1.2em;
}
.levelup-image{
    display: flex;
    justify-content: center;
    background-image: url('../assets/img/levelupbg.png');
    background-size: contain;
    min-height: 350px;
    flex-direction: column;
    align-items: center;
}
.levelup-title{
    text-align: center;
    font-size: 3em;
    font-family: 'american_typewriter', Courier, monospace;
    font-weight: bold;

}
.levelup-image img {
    width: 50%;
    max-height: 150px;
}
.levelup-text {
    margin-bottom: 1em;
}
.levelup-button {
  display: block;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1em;
  width: 60%;
  margin: 0 20%;
  border: none;
  padding: 2%;
}

@media (max-width: 360px) {
.levelup-container{
  width:inherit;
  padding:10px;
}
.levelup-image{
  min-height: 300px;
}
.levelup-text {
    margin-bottom: 0.5em;
    font-size: 0.8em;
}
}

</style>



// WEBPACK FOOTER //
// src/components/levelupModal.vue